import type { MenuRecipesState, RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'

export const getRecipeIdByCoreId =
  (coreId: RecipeCoreId) =>
  (state: MenuRecipesState): RecipeUUID | null =>
    state.recipesV3.coreIdToUUID[coreId] || null
